export default "__VITE_ASSET__CMTKU8_R__"